import { render } from "./SidebarGroupLabel.vue?vue&type=template&id=347d6c18&ts=true"
import script from "./SidebarGroupLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarGroupLabel.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarGroupLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "347d6c18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('347d6c18', __exports__)) {
    api.reload('347d6c18', __exports__)
  }
  
  module.hot.accept("./SidebarGroupLabel.vue?vue&type=template&id=347d6c18&ts=true", () => {
    api.rerender('347d6c18', render)
  })

}


export default __exports__